// languages for which we have meta data in intent/bot meta
export let LOCALE = /*#__PURE__*/function (LOCALE) {
  LOCALE["EN"] = "en";
  LOCALE["DE"] = "de";
  LOCALE["ES"] = "es";
  LOCALE["FR"] = "fr";
  LOCALE["IT"] = "it";
  LOCALE["PT"] = "pt";
  LOCALE["RU"] = "ru";
  LOCALE["JA"] = "ja";
  LOCALE["KO"] = "ko";
  LOCALE["TR"] = "tr";
  LOCALE["HE"] = "he";
  LOCALE["NL"] = "nl";
  LOCALE["PL"] = "pl";
  LOCALE["VI"] = "vi";
  LOCALE["ID"] = "id";
  LOCALE["NO"] = "no";
  LOCALE["SV"] = "sv";
  LOCALE["DA"] = "da";
  return LOCALE;
}({});
export const DEFAULT_LANGUAGE = LOCALE.EN;
// wix-languages, for which we have translated product strings
export const SUPPORT_LANGUAGE = [DEFAULT_LANGUAGE, LOCALE.DE, LOCALE.ES, LOCALE.FR, LOCALE.IT, LOCALE.NL, LOCALE.NO, LOCALE.PL, LOCALE.PT, LOCALE.RU, LOCALE.SV, LOCALE.JA, LOCALE.KO, LOCALE.TR, LOCALE.DA, 'hi', 'cs', 'th', 'zh', 'uk'];
export const hour12Map = {
  en: true,
  ja: true,
  ko: true,
  he: true,
  // because he,vi,id are fallbacked by en
  vi: true,
  id: true,
  de: false,
  es: false,
  fr: false,
  it: false,
  nl: false,
  pt: false,
  ru: false,
  tr: false,
  pl: false,
  no: false,
  da: false,
  sv: false
};
export const bcpLanguagesCodes = {
  en: 'en-US',
  pt: 'pt-BR',
  es: 'es-ES',
  it: 'it-IT',
  fr: 'fr-FR',
  de: 'de-DE',
  ko: 'ko-KR',
  ja: 'ja-JP',
  ru: 'ru-RU',
  tr: 'tr-TR',
  pl: 'pl-PL',
  nl: 'nl-NL',
  no: 'no-NO',
  da: 'da-DK',
  sv: 'sv-SE',
  //  he,vi,id are fallbacked by en
  he: 'en-US',
  vi: 'en-US',
  id: 'en-US'
  // hi: 'hi-IN',
  // cs: 'cs-CZ',
  // th: 'th-TH',
  // zh: 'zh-CN',
  // uk: 'uk-UA',
};
//# sourceMappingURL=locale.js.map